import type { SVGProps } from "react";

export function CctvIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M12 16C13.3807 16 14.5 14.8807 14.5 13.5C14.5 12.1193 13.3807 11 12 11C10.6193 11 9.5 12.1193 9.5 13.5C9.5 14.8807 10.6193 16 12 16ZM12 8C8.96243 8 6.5 10.4624 6.5 13.5C6.5 16.5376 8.96243 19 12 19C15.0376 19 17.5 16.5376 17.5 13.5C17.5 10.4624 15.0376 8 12 8ZM8 13.5C8 11.2909 9.79086 9.5 12 9.5C14.2091 9.5 16 11.2909 16 13.5C16 15.7091 14.2091 17.5 12 17.5C9.79086 17.5 8 15.7091 8 13.5ZM2 3.75C2 2.78351 2.78351 2 3.75 2H20.25C21.2165 2 22 2.78351 22 3.75V5.25C22 5.94809 21.5912 6.55075 21 6.8316V13C21 17.9706 16.9706 22 12 22C7.02945 22 3 17.9706 3 13V6.8316C2.40875 6.55075 2 5.94809 2 5.25V3.75ZM4.5 7V13C4.5 17.1422 7.85785 20.5 12 20.5C16.1422 20.5 19.5 17.1422 19.5 13V7H4.5ZM3.75 3.5C3.61193 3.5 3.5 3.61193 3.5 3.75V5.25C3.5 5.38807 3.61193 5.5 3.75 5.5H20.25C20.3881 5.5 20.5 5.38807 20.5 5.25V3.75C20.5 3.61193 20.3881 3.5 20.25 3.5H3.75Z"
        fill="#6B7280"
      />
    </svg>
  );
}
